/**
 * Reachable with no session at all.
 *
 * ITS OWN, IMPORT-FREE MODULE because the build reads it too: `vite.plugins.ts` skips the early
 * session request on these pages, where nobody is signed in and asking would be a wasted 401. One
 * list, so a public page added here cannot be one the build still treats as signed in.
 */
export const PUBLIC_PATHS = ['/login', '/set-password', '/signup', '/privacy', '/terms'] as const;
